
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_brdst_1irjx_145",
  "loading": "awsui_loading_brdst_1irjx_149",
  "undo-button": "awsui_undo-button_brdst_1irjx_153"
};
  